import { NgModule } from '@angular/core';

import { LIB_CommonModule } from "pbc.angular";

import { FeldService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [
    FeldService,
  ],
  exports: []
})
export class FeldServiceModule { }
